import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="prefix__Group_2057"
      width={65.398}
      height={65.398}
      viewBox="0 0 65.398 65.398"
      {...props}
    >
      <defs>
        <style>{'.prefix__cls-2{fill:#fff !important}'}</style>
      </defs>
      <path
        id="prefix__Path_5538"
        fill="#ed1b24"
        d="M468.518 70.966v42.309a11.547 11.547 0 01-11.548 11.542h-42.3a11.546 11.546 0 01-11.548-11.542V70.966a11.548 11.548 0 0111.548-11.547h42.3a11.548 11.548 0 0111.548 11.547z"
        transform="translate(-403.12 -59.419)"
      />
      <g id="prefix__Group_2053" transform="translate(10.457 15.828)">
        <path
          id="prefix__Path_5539"
          d="M434.064 80.9h9.636l6.756-8.778h-9.121z"
          className="prefix__cls-2"
          transform="translate(-405.972 -72.124)"
        />
        <path
          id="prefix__Path_5540"
          d="M427.15 92.3h17.45v4.892h-12.761a12.96 12.96 0 01-3.985-.578 9.707 9.707 0 01-3.151-1.642 7.2 7.2 0 01-2.065-2.544 7.366 7.366 0 01-.736-3.305 7.22 7.22 0 01.759-3.305 8.156 8.156 0 012.093-2.591 9.453 9.453 0 013.157-1.717 12.278 12.278 0 013.929-.6h4.79l7.293-8.778h-12.084a26.705 26.705 0 00-8.117 1.183 19.365 19.365 0 00-6.432 3.381 15.965 15.965 0 00-4.241 5.243 14.781 14.781 0 00-1.535 6.737 15.4 15.4 0 001.535 6.833 16.669 16.669 0 004.241 5.447 20.1 20.1 0 006.432 3.608 24.386 24.386 0 008.117 1.309h23.153V84.782H433.4z"
          className="prefix__cls-2"
          transform="translate(-411.514 -72.124)"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
